import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TemplateType, EmailTemplateMentionSuggestions, LetterTemplateMentionSuggestions, SMSTemplateMentionSuggestions, TemplateMentionSuggestions, } from '@debbie/common/dist/templates';
import { Table } from '..';
const MentionExplanation = (props) => {
    const lang = useSelector((s) => s.lang);
    const [templateTags, setTemplateTags] = useState(null);
    const updateTags = () => {
        if (!props.type) {
            setTemplateTags(TemplateMentionSuggestions);
        }
        else {
            switch (props.type) {
                case TemplateType.EMAIL:
                    setTemplateTags(EmailTemplateMentionSuggestions);
                    break;
                case TemplateType.SMS:
                    setTemplateTags(SMSTemplateMentionSuggestions);
                    break;
                case TemplateType.LETTER:
                    setTemplateTags(LetterTemplateMentionSuggestions);
                    break;
                default:
                    setTemplateTags(TemplateMentionSuggestions);
            }
        }
    };
    useEffect(() => {
        updateTags();
    }, []);
    if (!templateTags) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement(Table, { zebra: true },
            React.createElement("tr", null,
                React.createElement("th", null, lang.interactions.mention),
                React.createElement("th", null, lang.interactions.explanation),
                React.createElement("th", null, lang.interactions.example)),
            templateTags.map((tag) => (React.createElement("tr", { key: tag },
                React.createElement("td", null, '@' + lang.mentions[tag]),
                React.createElement("td", null, lang.mentionsExplanation[tag]),
                React.createElement("td", null, lang.mentionsExample[tag])))))));
};
export default MentionExplanation;
//# sourceMappingURL=MentionExplanation.js.map